export enum NotifyType {
  error = "error",
  info = "info",
  success = "success",
  warning = "warning",
}

export enum HistoryCourses {
  daily = 1,
  threeDays = 2,
  weekly = 3,
  fifteenDays = 4,
  monthly = 5,
  trimester = 6,
  sixMonths = 7,
  oneYear = 8,
  all = 9,
}

export enum TradeHistoyType {
  buy = 1,
  sell = 2,
}

export enum FlagType {
  none = 0,
  barasiBishtar = 1,
  dobuleCheck = 2,
}
